
import { Campaign } from '@/utils/models';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class CampaignPopup extends Vue {
  @Prop()
  campaign!: Campaign;

  @Emit('onClose')
  onClose(id: string) {}

  onCloseButtonClick() {
    this.onClose(this.campaign.id);
  }
}
